module.exports = __webpack_public_path__ + "a10924ad120df40a8753a2d22946d6f0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/writing-s.png
// module id = 1713
// module chunks = 0